<template>
  <div class="article-outline-container">
    <div class="article-title">{{ title }}</div>
    <span class="article-page">{{ page }}</span>
  </div>
</template>
<script>
export default {
  name: "ArticleOutline",
  props: ["title", "page"]
};
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";

.article-outline-container {
  font-family: Impact, sans-serif;
  position: absolute;
  bottom: 35px;
  left: 0;

  .article-title {
    // font-size: 52px;
    font-size:3vw;
    padding-left: 50px;
    line-height: 1;
    color: $font-color-gray;
    border-bottom: 2px solid $font-color-gray;
  }
  .article-page {
    position: fixed;
    right: 45px;
    // font-size: 72px;
    font-size:5.5vw;
    color: #67e7d3;
    transform: translateY(-5vw);
  }
}
</style>
